// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// NOTE: This file is automatically generated during build time.
// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export default {
        chrome: {
          appearance: '83',
          userSelect: '53',
          textEmphasisPosition: '98',
          textEmphasis: '98',
          textEmphasisStyle: '98',
          textEmphasisColor: '98',
          boxDecorationBreak: '129',
          clipPath: '54',
          maskImage: '119',
          maskMode: '119',
          maskRepeat: '119',
          maskPosition: '119',
          maskClip: '119',
          maskOrigin: '119',
          maskSize: '119',
          maskComposite: '119',
          mask: '119',
          maskBorderSource: '119',
          maskBorderMode: '119',
          maskBorderSlice: '119',
          maskBorderWidth: '119',
          maskBorderOutset: '119',
          maskBorderRepeat: '119',
          maskBorder: '119',
          maskType: '119',
          textDecorationStyle: '56',
          textDecorationSkip: '56',
          textDecorationLine: '56',
          textDecorationColor: '56',
          filter: '52',
        },
        android: {
          borderImage: '4.2',
          borderImageOutset: '4.2',
          borderImageRepeat: '4.2',
          borderImageSlice: '4.2',
          borderImageSource: '4.2',
          borderImageWidth: '4.2',
          flex: '4.2',
          flexBasis: '4.2',
          flexDirection: '4.2',
          flexGrow: '4.2',
          flexFlow: '4.2',
          flexShrink: '4.2',
          flexWrap: '4.2',
          alignContent: '4.2',
          alignItems: '4.2',
          alignSelf: '4.2',
          justifyContent: '4.2',
          order: '4.2',
          transition: '4.2',
          transitionDelay: '4.2',
          transitionDuration: '4.2',
          transitionProperty: '4.2',
          transitionTimingFunction: '4.2',
          transform: '4.4',
          transformOrigin: '4.4',
          transformOriginX: '4.4',
          transformOriginY: '4.4',
          backfaceVisibility: '4.4',
          perspective: '4.4',
          perspectiveOrigin: '4.4',
          transformStyle: '4.4',
          transformOriginZ: '4.4',
          animation: '4.4',
          animationDelay: '4.4',
          animationDirection: '4.4',
          animationFillMode: '4.4',
          animationDuration: '4.4',
          animationIterationCount: '4.4',
          animationName: '4.4',
          animationPlayState: '4.4',
          animationTimingFunction: '4.4',
          appearance: '4.4',
          userSelect: '4.4',
          fontKerning: '4.4',
          textEmphasisPosition: '4.4',
          textEmphasis: '4.4',
          textEmphasisStyle: '4.4',
          textEmphasisColor: '4.4',
          boxDecorationBreak: '4.4',
          clipPath: '4.4',
          maskImage: '4.4',
          maskMode: '4.4',
          maskRepeat: '4.4',
          maskPosition: '4.4',
          maskClip: '4.4',
          maskOrigin: '4.4',
          maskSize: '4.4',
          maskComposite: '4.4',
          mask: '4.4',
          maskBorderSource: '4.4',
          maskBorderMode: '4.4',
          maskBorderSlice: '4.4',
          maskBorderWidth: '4.4',
          maskBorderOutset: '4.4',
          maskBorderRepeat: '4.4',
          maskBorder: '4.4',
          maskType: '4.4',
          filter: '4.4',
          fontFeatureSettings: '4.4',
          breakAfter: '4.4',
          breakBefore: '4.4',
          breakInside: '4.4',
          columnCount: '4.4',
          columnFill: '4.4',
          columnGap: '4.4',
          columnRule: '4.4',
          columnRuleColor: '4.4',
          columnRuleStyle: '4.4',
          columnRuleWidth: '4.4',
          columns: '4.4',
          columnSpan: '4.4',
          columnWidth: '4.4',
          writingMode: '4.4',
        },
        firefox: {
          appearance: '79',
          userSelect: '68',
          tabSize: '90',
          breakAfter: '51',
          breakBefore: '51',
          breakInside: '51',
          columnCount: '51',
          columnFill: '51',
          columnGap: '51',
          columnRule: '51',
          columnRuleColor: '51',
          columnRuleStyle: '51',
          columnRuleWidth: '51',
          columns: '51',
          columnSpan: '51',
          columnWidth: '51',
        },
        ios_saf: {
          appearance: '15.2',
          userSelect: '18.3',
          backdropFilter: '17.6',
          fontKerning: '11.3',
          scrollSnapType: '10.3',
          scrollSnapPointsX: '10.3',
          scrollSnapPointsY: '10.3',
          scrollSnapDestination: '10.3',
          scrollSnapCoordinate: '10.3',
          boxDecorationBreak: '18.3',
          clipPath: '12.2',
          maskImage: '15.2',
          maskMode: '15.2',
          maskRepeat: '15.2',
          maskPosition: '15.2',
          maskClip: '15.2',
          maskOrigin: '15.2',
          maskSize: '15.2',
          maskComposite: '15.2',
          mask: '15.2',
          maskBorderSource: '15.2',
          maskBorderMode: '15.2',
          maskBorderSlice: '15.2',
          maskBorderWidth: '15.2',
          maskBorderOutset: '15.2',
          maskBorderRepeat: '15.2',
          maskBorder: '15.2',
          maskType: '15.2',
          textSizeAdjust: '18.3',
          textDecorationStyle: '18.3',
          textDecorationSkip: '18.3',
          textDecorationLine: '18.3',
          textDecorationColor: '18.3',
          shapeImageThreshold: '10',
          shapeImageMargin: '10',
          shapeImageOutside: '10',
          hyphens: '16.6',
          flowInto: '11',
          flowFrom: '11',
          breakBefore: '11',
          breakAfter: '11',
          breakInside: '11',
          regionFragment: '11',
          writingMode: '10.3',
        },
        safari: {
          appearance: '15.2',
          userSelect: '18.3',
          backdropFilter: '17.6',
          scrollSnapType: '10.1',
          scrollSnapPointsX: '10.1',
          scrollSnapPointsY: '10.1',
          scrollSnapDestination: '10.1',
          scrollSnapCoordinate: '10.1',
          boxDecorationBreak: '18.3',
          clipPath: '13',
          maskImage: '15.2',
          maskMode: '15.2',
          maskRepeat: '15.2',
          maskPosition: '15.2',
          maskClip: '15.2',
          maskOrigin: '15.2',
          maskSize: '15.2',
          maskComposite: '15.2',
          mask: '15.2',
          maskBorderSource: '15.2',
          maskBorderMode: '15.2',
          maskBorderSlice: '15.2',
          maskBorderWidth: '15.2',
          maskBorderOutset: '15.2',
          maskBorderRepeat: '15.2',
          maskBorder: '15.2',
          maskType: '15.2',
          textDecorationStyle: '12',
          textDecorationSkip: '12',
          textDecorationLine: '12',
          textDecorationColor: '12',
          shapeImageThreshold: '10',
          shapeImageMargin: '10',
          shapeImageOutside: '10',
          hyphens: '16.6',
          flowInto: '11',
          flowFrom: '11',
          breakBefore: '11',
          breakAfter: '11',
          breakInside: '11',
          regionFragment: '11',
          writingMode: '10.1',
          textOrientation: '13.1',
        },
        edge: {
          appearance: '83',
          userSelect: '18',
          wrapFlow: '18',
          wrapThrough: '18',
          wrapMargin: '18',
          scrollSnapType: '18',
          scrollSnapPointsX: '18',
          scrollSnapPointsY: '18',
          scrollSnapDestination: '18',
          scrollSnapCoordinate: '18',
          textEmphasisPosition: '98',
          textEmphasis: '98',
          textEmphasisStyle: '98',
          textEmphasisColor: '98',
          boxDecorationBreak: '129',
          maskImage: '119',
          maskMode: '119',
          maskRepeat: '119',
          maskPosition: '119',
          maskClip: '119',
          maskOrigin: '119',
          maskSize: '119',
          maskComposite: '119',
          mask: '119',
          maskBorderSource: '119',
          maskBorderMode: '119',
          maskBorderSlice: '119',
          maskBorderWidth: '119',
          maskBorderOutset: '119',
          maskBorderRepeat: '119',
          maskBorder: '119',
          maskType: '119',
          textSizeAdjust: '18',
          hyphens: '18',
          flowInto: '18',
          flowFrom: '18',
          breakBefore: '18',
          breakAfter: '18',
          breakInside: '18',
          regionFragment: '18',
          gridTemplateColumns: '15',
          gridTemplateRows: '15',
          gridTemplateAreas: '15',
          gridTemplate: '15',
          gridAutoColumns: '15',
          gridAutoRows: '15',
          gridAutoFlow: '15',
          grid: '15',
          gridRowStart: '15',
          gridColumnStart: '15',
          gridRowEnd: '15',
          gridRow: '15',
          gridColumn: '15',
          gridColumnEnd: '15',
          gridColumnGap: '15',
          gridRowGap: '15',
          gridArea: '15',
          gridGap: '15',
        },
        opera: {
          appearance: '72',
          userSelect: '40',
          textEmphasisPosition: '85',
          textEmphasis: '85',
          textEmphasisStyle: '85',
          textEmphasisColor: '85',
          boxDecorationBreak: '114',
          clipPath: '41',
          maskImage: '105',
          maskMode: '105',
          maskRepeat: '105',
          maskPosition: '105',
          maskClip: '105',
          maskOrigin: '105',
          maskSize: '105',
          maskComposite: '105',
          mask: '105',
          maskBorderSource: '105',
          maskBorderMode: '105',
          maskBorderSlice: '105',
          maskBorderWidth: '105',
          maskBorderOutset: '105',
          maskBorderRepeat: '105',
          maskBorder: '105',
          maskType: '105',
          textDecorationStyle: '43',
          textDecorationSkip: '43',
          textDecorationLine: '43',
          textDecorationColor: '43',
          filter: '39',
          fontFeatureSettings: '34',
          breakAfter: '36',
          breakBefore: '36',
          breakInside: '36',
          columnCount: '36',
          columnFill: '36',
          columnGap: '36',
          columnRule: '36',
          columnRuleColor: '36',
          columnRuleStyle: '36',
          columnRuleWidth: '36',
          columns: '36',
          columnSpan: '36',
          columnWidth: '36',
          writingMode: '34',
        },
        and_uc: {
          boxDecorationBreak: '15.5',
          maskImage: '15.5',
          maskMode: '15.5',
          maskRepeat: '15.5',
          maskPosition: '15.5',
          maskClip: '15.5',
          maskOrigin: '15.5',
          maskSize: '15.5',
          maskComposite: '15.5',
          mask: '15.5',
          maskBorderSource: '15.5',
          maskBorderMode: '15.5',
          maskBorderSlice: '15.5',
          maskBorderWidth: '15.5',
          maskBorderOutset: '15.5',
          maskBorderRepeat: '15.5',
          maskBorder: '15.5',
          maskType: '15.5',
        },
        and_chr: {},
        samsung: {
          appearance: '13',
          userSelect: '5',
          textEmphasisPosition: '17',
          textEmphasis: '17',
          textEmphasisStyle: '17',
          textEmphasisColor: '17',
          boxDecorationBreak: '27',
          clipPath: '5',
          maskImage: '24',
          maskMode: '24',
          maskRepeat: '24',
          maskPosition: '24',
          maskClip: '24',
          maskOrigin: '24',
          maskSize: '24',
          maskComposite: '24',
          mask: '24',
          maskBorderSource: '24',
          maskBorderMode: '24',
          maskBorderSlice: '24',
          maskBorderWidth: '24',
          maskBorderOutset: '24',
          maskBorderRepeat: '24',
          maskBorder: '24',
          maskType: '24',
          filter: '6.2',
          fontFeatureSettings: '4',
          breakAfter: '4',
          breakBefore: '4',
          breakInside: '4',
          columnCount: '4',
          columnFill: '4',
          columnGap: '4',
          columnRule: '4',
          columnRuleColor: '4',
          columnRuleStyle: '4',
          columnRuleWidth: '4',
          columns: '4',
          columnSpan: '4',
          columnWidth: '4',
          writingMode: '4',
        },
}
